import { Tab } from '@headlessui/react'
import { propOr } from 'ramda'

import useProgram from '../stores/use-program'

const programSelector = propOr({}, 'program')

const Description = () => {
  const program = useProgram(programSelector)
  const createMarkup = () => {
    return { __html: `${program.description}` }
  }
  return (
    <Tab.Panel className='pt-10'>
      <div
        className='custom-font-24 program-desc'
        dangerouslySetInnerHTML={createMarkup()}
      />
    </Tab.Panel>
  )
}

export default Description
